import React from "react";
import Faqs from "../faqs/Faqs";
import profile from "../../app/assets/img/aadi-logo-black.png";
import "./MessageScreen.scss";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import logo from "../../app/assets/img/pg-logo3.webp";
import { useMediaQuery } from 'react-responsive';
import FaqsPopup from "../faqs/FaqsPopup";

const MessageScreenPopUp = ({ setUserInput, handleExternalTextClick }) => {
  const isTab = useMediaQuery({ query: "(max-width: 768px)" });
  return (
    <div className="messaageScreen pt-0 px-3">
      <div
        style={{
          fontSize: "34px",
          fontWeight: "600",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "relative",
          // marginLeft: '12px',
        }}
      >
        <img style={{ width:isTab ? "48px":"60px" }} src={logo} alt="Aadi" />
        {/* <span
          style={{
            position: "absolute",
            background: "#37a5c6",
            fontSize: "9px",
            padding: "2px",
            right: "-10px",
            bottom: "-19px",
            fontFamily: "Ahganirya",
            fontWeight: "normal",
            paddingTop: "3px",
            color: "white",
          }}
        >
          BETA
        </span> */}
      </div>

      <div
        style={{
          fontSize: isTab ? "20px" : "24px",
          fontWeight: "600",
          paddingLeft: "10px",
        }}
      >
        Hello again
      </div>
      <div style={{ paddingLeft: "10px", fontSize:isTab ? "15px":"12px"}}>
        Tell me what’s on your mind, or pick a suggestion.
      </div>

      <div
        style={{
          paddingLeft: "10px",
          display: "none",
        }}
      >
        Would you like to continue with?
      </div>

      <div
        style={{
          paddingLeft: "10px",
          fontWeight: "600",
          display: "grid",
          gap: "10px",
          textAlign: "left",
        }}
      >
        <FaqsPopup
          handleExternalTextClick={handleExternalTextClick}
          setUserInput={setUserInput}
        />
      </div>
    </div>
  );
};

export default MessageScreenPopUp;
